import { apiClient } from '../../api/client';
import { endpoints } from '../../api/endpoints';
import type { AdminPreOrder, PreOrder, PreOrderInput, PreOrderStatus } from '../../types';
import type {
  AdminPreOrderListResponse,
  PreOrderCreateResponse,
  PreOrderListResponse,
} from '../../types/api';

export async function httpFetchPreOrders(): Promise<PreOrder[]> {
  const response = await apiClient<PreOrderListResponse | PreOrder[]>(endpoints.preOrders.list);
  return Array.isArray(response) ? response : response.preOrders;
}

export async function httpCreatePreOrder(input: PreOrderInput): Promise<PreOrder> {
  const response = await apiClient<PreOrderCreateResponse | PreOrder>(endpoints.preOrders.create, {
    method: 'POST',
    body: {
      productId: input.productId,
      quantity: input.quantity,
      contact: input.contact,
      note: input.note?.trim() || null,
    },
  });

  return 'preOrder' in response ? response.preOrder : response;
}

export async function httpFetchAdminPreOrders(
  status?: PreOrderStatus,
): Promise<AdminPreOrder[]> {
  const query = status ? `?status=${encodeURIComponent(status)}` : '';
  const response = await apiClient<AdminPreOrderListResponse | AdminPreOrder[]>(
    `${endpoints.admin.preOrders.list}${query}`,
  );
  return Array.isArray(response) ? response : response.preOrders;
}

export async function httpUpdateAdminPreOrder(
  id: string,
  status: 'fulfilled' | 'cancelled',
  adminNote?: string | null,
): Promise<AdminPreOrder> {
  return apiClient<AdminPreOrder>(endpoints.admin.preOrders.update(id), {
    method: 'PATCH',
    body: {
      status,
      adminNote: adminNote?.trim() || null,
    },
  });
}
